// /env.ts
export const getEnv = () => {
  const config = useRuntimeConfig()

  return {
    nodeEnv: config.public.NODE_ENV as string,
    firebaseApiKey: config.public.FIREBASE_API_KEY as string,
    firebaseProjectId: config.public.FIREBASE_PROJECT_ID as string,
    firebaseAuthDomain: config.public.FIREBASE_AUTH_DOMAIN as string,
    kakaoRestApiKey: config.public.KAKAO_REST_API_KEY as string,
    // Ensure encryption values are read from public for client-side usage
    getEncryptionKey: (config.public as any).ENCRYPTION_KEY as string,
    getEncryptionIv: (config.public as any).ENCRYPTION_IV as string,
  }
}

// export const getNodeEnv = () => getEnv().nodeEnv
// export const getFirebaseProjectId = () => getEnv().firebaseProjectId
export const getEncryptionKey = () => getEnv().getEncryptionKey
